<template>
    <div class="loading-main">
        <loader-oval-blue
            class="loading-main__circle"
            style=""
        ></loader-oval-blue>
    </div>
</template>

<script>
import LoaderOvalBlue from 'Images/loaders/oval-blue.svg?inline';

export default {
    name: 'LoadingMain',
    components: {
        LoaderOvalBlue,
    },
};
</script>

<style scoped lang="scss">
.loading-main {
    height: 70rem;
    background: white;
    &__circle {
        margin: 25% auto auto 45%;
        height: 500px;
        @media (max-width: $sm-up) {
            margin: 30% auto auto 35%;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 50% auto auto 35%;
            height: 300px;
        }
    }
}
</style>
